.<style lang="scss" scoped>
.table-container {
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    border: 1px solid var(--border-color);
    overflow: auto;
}
.table-filter {
    display: flex;
    flex-flow: row;
    margin: 0 16px;
}
.alter-table-columns {
    border-radius: 2px;
    border: 1px solid var(--border-color);
    background-color: #ffffff;
    width: 225px;
    position: absolute;
    right: 0;
    padding: 16px 4px;
    z-index: 1;
    .item {
        padding: 10px 16px;
        color: var(--primary-dark);
        &:hover {
            background-color: rgba(15, 50, 97, 0.05);
        }
    }
}
</style>

<style lang="scss">
.sort-icon {
    .sort_svg__top,
    .sort_svg__bottom {
        opacity: 0.5;
    }
    &.asc {
        .sort_svg__top {
            opacity: 0;
        }
        .sort_svg__bottom {
            opacity: 1;
        }
    }
    &.desc {
        .sort_svg__top {
            opacity: 1;
        }
        .sort_svg__bottom {
            opacity: 0;
        }
    }
}
.table-row {
    &.new-row {
        .small {
            font-weight: 900 !important;
        }
    }
    &.row-disabled {
        cursor: auto !important;
        background: var(--white-hover);
        pointer-events: none;
    }
}
.table-cell {
    flex: none;
    &:not(.table-edit) {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    &.type-select {
        //flex: 0 0 30px;
        width: 30px;
    }
    &.type-user {
        // flex: 0 0 180px;
        width: 180px;
    }
    &.type-text,
    &.type-translated,
    &.type-date,
    &.size-text {
        // flex: 0 0 165px;
        width: 165px;
    }
    &.size-normal {
        // flex: 0 0 150px !important;
        width: 150px;
    }
    &.size-small {
        // flex: 0 0 120px !important;
        width: 120px;
    }
    &.size-edit {
        // flex: 0 0 50px !important;
        width: 50px;
    }
    &.size-xsmall {
        // flex: 0 0 90px !important;
        width: 90px;
    }
    &.size-xxsmall {
        // flex: 0 0 90px !important;
        width: 50px;
    }
    &:not(:first-child) {
        padding: 0 8px;
    }
    &:not(:first-child) {
        padding: 0 8px;
    }
    &.table-edit {
        user-select: none;
    }
}
</style>


<template>
    <div>

        <!-- Header -->
        <div class="table-header row mb-44">
            <slot name="search" v-if="searchable.length > 0">
                <div class="col-12 col-md-4 col-lg-3">
                    <el-input v-model="search" type="text" class="small mb-0" :name="$t('form-elements.search')" :hasLabel="false" :placeholder="$t('form-elements.search_placeholder')"></el-input>
                </div>
            </slot>

            <slot name="header">

            </slot>
        </div>

        <!-- Filter -->
        <div class="table-filter mb-8 mr-0 position-relative" style="overflow: hidden visible;" ref="filter">
            <div class="d-flex w-100">
                <div v-for="(value, index) in structure.filter((s) => s.visible )" :key="index" class="table-cell" :class="['type-' + value.type, 'size-' + value.size]">
                    <p-check v-if="value.type === 'select'" v-model="selected" class="p-curve p-svg p-jelly my-auto mr-0" color="primary" name="check">
                        <i-check slot="extra" class="svg svg-icon"></i-check>
                    </p-check>
                    <span class="small c-pointer" v-else>
                        <span v-if="value.sortable" @click.prevent="order = { type: value.type , column: value.key, asc: order ? !order.asc : false }">
                            <span class="us-none">{{ value.label }}</span>
                            <i-sort class="i-8 ml-8 sort-icon" :class="[order && order.column === value.key ? { asc : order.asc, desc : !order.asc } : null]"></i-sort>
                        </span>
                        <span v-else>
                            {{ value.label }}
                        </span>
                    </span>
                </div>
                <div v-if="editable" class="table-cell table-edit px-0 text-right ml-auto size-edit" @click="showAlterTableColumns = !showAlterTableColumns">
                    <span class="c-pointer my-auto ml-auto text-primary-dark small">{{ $t('general.change')}}</span>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="position-relative" v-click-outside="() => { showAlterTableColumns = false  }">
            <div @click.stop v-if="showAlterTableColumns" class="alter-table-columns">
                <div class="item d-flex w-100" v-for="( item, item_index) in structure.filter((s) => s.label )" :key="item_index">
                    <p-check v-model="item.visible" @change="itemsChanged" class="p-curve p-svg p-jelly my-auto mr-auto w-100 text-left" color="success" name="check">
                        <i-check slot="extra" class="svg svg-icon"></i-check>
                        {{ item.label }}
                    </p-check>
                </div>
            </div>
        </div>
        <div class="table-container" @scroll="onScroll">
            <template v-if="filteredRows.length > 0">
                <el-row v-for="(row, index) in filteredRows" :key="`${index}_${row.selected}`" :data="row" :structure="structure" :class="{ 'can-hover' : detail !== '', 'new-row': isNewRow(row), 'row-disabled': row.id === null }" @click="goToRow(row.id)" :url="getUrl(row.id)" :editable="editable"></el-row>

                <template v-if="meta && meta.current_page !== undefined">
                    <a class="text-center text-primary w-100 d-block my-24 small" v-if="!loading && meta.current_page < meta.last_page" href="javascript:void(0)" @click="this.meta.page = this.meta.current_page + 1; handleMetaChanged()" v-html="$t('general.load_more')"></a>
                    <span class="d-block text-center text-gray my-24 small" v-else-if="loading && meta.current_page < meta.last_page" v-html="$t('general.loading')"></span>
                    <span class="d-block text-center text-gray my-24 small" v-else v-html="$t('general.no-more-results')"></span>
                </template>
            </template>

            <template v-else>
                <span v-if="!loading" class="d-block text-center text-gray my-16 small" v-html="$t('general.no-results')"></span>
                <span v-else class="d-block text-center text-gray my-16 small" v-html="$t('general.loading')"></span>
            </template>
        </div>
    </div>
</template>

<script>
import ElRow from './row'
import { PCheck, ElInput } from '@/components/forms'

export default {
    components: { ElRow, PCheck, ElInput },
    props: {
        rows: {
            type: Array,
            required: true
        },
        structure: {
            type: Array,
            require: true
        },
        detail: {
            type: String,
            require: false,
            default: ''
        },
        searchable: {
            type: Array,
            require: false,
            default: () => {
                return []
            }
        },
        editable: {
            type: Boolean,
            default: true
        },
        queryParameters: {
            required: false,
            type: Object,
            default: () => {
                return {}
            }
        },
        loading: {
            required: false,
            default: false,
        },
        meta: {
            required: false,
        },
        newRowCondition: {
            required: false,
            default() {
                return function () { return false }
            }
        },
        serverSideSorting: {
            required: false,
            default: false,
        }
    },
    data: () => ({
        selected: false,
        showAlterTableColumns: false,
        order: null,
        localRows: [],
        search: '',
        prevScrollTop: 0
    }),
    mounted() {
        if (this.$route.query.search) this.search = this.$route.query.search
        if (this.$route.query.order_type) this.order = { type: this.$route.query.order_type, column: this.$route.query.order_column, asc: !!this.$route.query.asc }
        this.localRows = this.rows

        let items = JSON.parse(localStorage.getItem(`sts-table-${this.$parent.$options.name}-items`)) || []
        items.forEach(item => {
            let s = this.structure.find(s => s.key === item.key)
            s.visible = item.visible
        })
    },
    methods: {
        goToRow(id) {
            if (!this.detail || id === null) return

            this.$router.push(this.getRouteObject(id))
        },

        getUrl(id) {
            if (!this.detail || id === null) return

            return this.$router.match(this.getRouteObject(id)).fullPath
        },

        isNewRow(row) {
            return this.newRowCondition(row)
        },

        getRouteObject(id) {
            let query = {}
            if (this.search)
                query.search = this.search
            if (this.order) {
                query.order_type = this.order.type
                query.order_column = this.order.column
                query.asc = this.order.asc
            }
            if (this.queryParameters) {
                query = { ...query, ...this.queryParameters }
            }
            return { name: this.detail, params: { id: id }, query: query };
        },

        handleMetaChanged() {
            this.$emit('meta-changed', this.meta)
        },

        onScroll({ target: { scrollLeft, scrollTop, clientHeight, scrollHeight } }) {
            if (this.prevScrollTop === scrollTop) {
                this.$refs.filter.scrollLeft = scrollLeft
                return;
            }
            this.prevScrollTop = scrollTop
            if (!this.meta || this.meta.current_page === undefined || this.meta.last_page === this.meta.current_page) return;
            if (scrollTop + clientHeight >= scrollHeight) {
                this.meta.page = this.meta.current_page + 1
                this.handleMetaChanged()
            }
        },
        itemsChanged() {
            // localStorage.getItem(`sts-table-${this.$parent.$options.name}-items`)
            let items = this.structure.filter((s) => s.label).map(l => { return { visible: l.visible, key: l.key } })
            localStorage.setItem(`sts-table-${this.$parent.$options.name}-items`, JSON.stringify(items));
        }
    },
    computed: {
        filteredRows() {
            if (this.serverSideSorting) return this.localRows;
            let rows = []
            if (this.searchable.length > 0)
                rows = this.localRows.filter(row => {
                    if (this.searchable.some(key => { return row[key].toLowerCase().includes(this.search.toLowerCase()) })) return row
                })
            else rows = this.localRows

            if (this.order) {
                if (this.order.type === 'text' && this.order.column !== 'progress')
                    rows.sort((a, b) => {
                        return a[this.order.column].localeCompare(b[this.order.column]);
                    })
                if (this.order.type === 'text' && this.order.column === 'progress') {
                    rows.sort((a, b) => {
                        return parseInt(a[this.order.column].substr(1, a[this.order.column].indexOf(' '))) - parseInt(b[this.order.column].substr(1, b[this.order.column].indexOf(' ')))
                    })
                }
                if (this.order.type === 'number')
                    rows.sort((a, b) => {
                        return a[this.order.column] - b[this.order.column];
                    })
                if (this.order.type === 'user')
                    rows.sort((a, b) => {
                        return a.first_name.localeCompare(b.first_name);
                    })
                if (this.order.type === 'date' || this.order.type === 'follow_up_date')
                    rows.sort((a, b) => {
                        return new Date(a[this.order.column]) - new Date(b[this.order.column]);
                    })
                if (this.order.type === 'boolean')
                    rows.sort((a, b) => {
                        return a[this.order.column] - b[this.order.column];
                    })

                if (this.order.asc) rows.reverse()
            }

            return rows
        }
    },
    watch: {
        rows: function () {
            this.localRows = this.rows
        },
        selected: function () {
            let value = this.selected
            this.localRows.forEach(function (row, index) {
                this[index].selected = value
            }, this.localRows)
        },
        order: function (order) {
            if (!this.serverSideSorting) return;

            this.meta.page = 1;
            this.meta.sort = order.column;
            this.meta.order = (order.asc) ? 'asc' : 'desc';

            this.handleMetaChanged()
        },
        search: _.debounce(function (search) {
            if (!this.serverSideSorting) return;

            this.meta.page = 1;
            this.meta.q = search;

            this.handleMetaChanged()
        }, 500),
    },
    directives: {
        'click-outside': {
            bind: function (el, binding, vNode) {
                // Provided expression must evaluate to a function.
                if (typeof binding.value !== 'function') {
                    const compName = vNode.context.name
                    let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                    if (compName) { warn += `Found in component '${compName}'` }

                    console.warn(warn)
                }
                // Define Handler and cache it on the element
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler

                // add Event Listeners
                document.getElementById('app').addEventListener('click', handler, true)
            },

            unbind: function (el) {
                // Remove Event Listeners
                document.getElementById('app').removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        },
    },
}
</script>
